import * as React from 'react'

import { Box, MetaPill, Text } from '@doist/marketist'

import cn from 'classnames'

import css from './TagList.module.css'

export type TagListProps = {
    title: string
    platforms: string[]
    className?: string
}

export function TagList({
    title,
    platforms,
    className,
    ...rest
}: TagListProps & React.HTMLAttributes<HTMLDivElement>) {
    return (
        <Box className={cn(css.tagList, className)} {...rest}>
            <Text tag="h3" size="minor-xs">
                {title}
            </Text>

            <ul>
                {platforms.map((platform) => (
                    <MetaPill key={platform}>{platform}</MetaPill>
                ))}
            </ul>
        </Box>
    )
}
